function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 165,
  r: 165,
  fill: "#C4C4C4"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1367:2)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 165,
  cy: 164.985,
  rx: 165,
  ry: 164.985,
  fill: "url(#paint0_linear_1367:2)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_f_1367:2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M163.283 24.4L163 22.5L159.888 24L105 20L159.888 26.3063V28L162.5 26.3063L221 31L163.283 24.4Z",
  fill: "#F199FF"
})), /*#__PURE__*/React.createElement("path", {
  d: "M202 29L161.537 24.5L123 22L161.537 26L202 29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.7
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_f_1367:2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M218.382 49.6942L218.382 48.0001L216.5 49.5001L180 47.6272L216.296 52.0255L216 53.5001L217.5 52.0001L256.529 53.9797L218.382 49.6942Z",
  fill: "#F199FF"
})), /*#__PURE__*/React.createElement("path", {
  d: "M243.981 52.7413L217.246 49.8637L191.893 48.9055L217.337 51.3609L243.981 52.7413Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.3
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_f_1367:2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M269.868 82.5858L269.5 81L268 82.5L237 81L268 84L268 85.9796L269.5 84.5L302.529 85.9796L269.868 82.5858Z",
  fill: "#F199FF"
})), /*#__PURE__*/React.createElement("path", {
  d: "M291.786 85.0028L268.895 82.7268L247.183 82.011L268.969 83.9463L291.786 85.0028Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.3
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_f_1367:2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M113.668 53.4L113 53L111.649 52.8L79 51L111.649 54.6H112.5H113.668L148 57L113.668 53.4Z",
  fill: "#F199FF"
})), /*#__PURE__*/React.createElement("path", {
  d: "M136.698 55.9091L112.63 53.4546L89.707 52.0909L112.63 54.2728L136.698 55.9091Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("path", {
  opacity: 0.99,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M325.5 202.982C324.504 197.26 324.071 196.35 322.013 191.474C317.238 180.154 310.069 171.074 302.663 163.994C295.29 156.948 287.694 151.886 281.977 148.614C276.401 145.421 272.616 143.916 272.616 143.916C272.719 143.889 272.822 143.87 272.925 143.845C276.531 142.948 280.226 142.876 283.728 143.247C292.328 144.155 299.699 147.764 301.349 148.618C301.573 148.734 301.694 148.803 301.694 148.803C297.24 142.922 292.213 137.794 286.964 133.317C262.766 112.676 233.794 106.12 233.794 106.12C233.959 106.036 234.139 105.962 234.315 105.885C243.211 102.006 265.995 106.12 265.995 106.12C265.842 106.013 265.688 105.91 265.533 105.804C234.827 84.6665 188.48 80.7795 188.48 80.7795C189.5 66.5 140.5 60 129 50C127 59 128.023 70.2086 128 76C118 76 112.923 74.7873 105.5 70.5C102.5 83 108.5 91 113.93 97.3637C76.6261 134.704 92.4963 165.137 92.4963 171.085C92.4963 177.51 62.5 219 62.5 219C62.5 219 62.5 224 66.5 226.5C69.8115 228.57 81.8071 233.339 87 236.5C100.5 244 117.668 229.234 133.5 219.48C196.269 180.804 224.656 240.023 210 287.974C204.575 305.724 237.974 313.123 251.5 305.472C278 290.484 315 253.477 325.5 202.982Z",
  fill: "url(#paint1_linear_1367:2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M246.18 126.132C212.516 124.106 273.128 144.19 273.128 144.19L273.23 144.21L273.416 144.244C277.015 143.359 280.704 143.288 284.199 143.653C292.782 144.551 300.14 148.112 301.786 148.954C301.838 148.963 301.891 148.971 301.944 148.978L302 148.987C302 148.987 279.843 128.158 246.18 126.132Z",
  fill: "url(#paint2_linear_1367:2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M246.18 126.132C212.516 124.106 273.128 144.19 273.128 144.19L273.23 144.21L273.416 144.244C277.015 143.359 280.704 143.288 284.199 143.653C292.782 144.551 300.14 148.112 301.786 148.954C301.838 148.963 301.891 148.971 301.944 148.978L302 148.987C302 148.987 279.843 128.158 246.18 126.132Z",
  fill: "url(#paint3_radial_1367:2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M167 83.5C142.5 79 129 50 129 50C125 56 124 80.2244 134.5 87.5C128.5 89 119.5 92 112.999 98C66.4997 145.5 156 130.5 197.5 112C204 90 149.5 85.5 149.5 85.5C149.5 85.5 154.5 83.5 167 83.5Z",
  fill: "url(#paint4_linear_1367:2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M167 83.5C142.5 79 129 50 129 50C125 56 124 80.2244 134.5 87.5C128.5 89 119.5 92 112.999 98C66.4997 145.5 156 130.5 197.5 112C204 90 149.5 85.5 149.5 85.5C149.5 85.5 154.5 83.5 167 83.5Z",
  fill: "url(#paint5_radial_1367:2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M254 303.973C270.511 235.778 236.734 216.16 225.061 211.525C237.5 211.525 255.5 215.223 269.5 235.5C259.903 190.038 213.239 171.188 171.737 184.5C145.237 193 96 225.225 85.5 227.363C75 229.5 70 227.5 66.5 226.5C70 229.5 85 237.136 91 238.5C118.114 244.662 143.516 215.141 171.737 222.585C189.936 227.384 202.607 247.216 203.378 265.294C203.467 272.78 202.257 280.12 198.55 288.675C190.427 307.422 177.924 315.999 158.5 322.34C141.979 327.733 114 321.971 114 321.971C143.5 332.47 203.5 337.97 254 303.973Z",
  fill: "url(#paint6_linear_1367:2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M282.672 176.134C315.628 179.492 325.5 202.982 325.5 202.982C324.795 207.916 323.136 213.468 321 217.98L282.672 176.134Z",
  fill: "url(#paint7_linear_1367:2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M254 303.973C270.511 235.778 236.734 216.16 225.061 211.525C237.5 211.525 255.5 215.223 269.5 235.5C259.903 190.038 213.239 171.188 171.737 184.5C145.237 193 96 225.225 85.5 227.363C75 229.5 70 227.5 66.5 226.5C70 229.5 85 237.136 91 238.5C118.114 244.662 143.516 215.141 171.737 222.585C189.936 227.384 202.607 247.216 203.378 265.294C203.467 272.78 202.257 280.12 198.55 288.675C190.427 307.422 177.924 315.999 158.5 322.34C141.979 327.733 114 321.971 114 321.971C143.5 332.47 203.5 337.97 254 303.973Z",
  fill: "url(#paint8_radial_1367:2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M282.672 176.134C315.628 179.492 325.5 202.982 325.5 202.982C324.795 207.916 323.136 213.468 321 217.98L282.672 176.134Z",
  fill: "url(#paint9_radial_1367:2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M254 303.973C270.511 235.778 236.734 216.16 225.061 211.525C237.5 211.525 255.5 215.223 269.5 235.5C259.903 190.038 213.239 171.188 171.737 184.5C145.237 193 96 225.225 85.5 227.363C75 229.5 70 227.5 66.5 226.5C70 229.5 85 237.136 91 238.5C118.114 244.662 143.516 215.141 171.737 222.585C189.936 227.384 202.607 247.216 203.378 265.294C203.467 272.78 202.257 280.12 198.55 288.675C190.427 307.422 177.924 315.999 158.5 322.34C141.979 327.733 114 321.971 114 321.971C143.5 332.47 203.5 337.97 254 303.973Z",
  fill: "url(#paint10_radial_1367:2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M282.672 176.134C315.628 179.492 325.5 202.982 325.5 202.982C324.795 207.916 323.136 213.468 321 217.98L282.672 176.134Z",
  fill: "url(#paint11_radial_1367:2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M254 303.973C270.511 235.778 236.734 216.16 225.061 211.525C237.5 211.525 255.5 215.223 269.5 235.5C259.903 190.038 213.239 171.188 171.737 184.5C145.237 193 96 225.225 85.5 227.363C75 229.5 70 227.5 66.5 226.5C70 229.5 85 237.136 91 238.5C118.114 244.662 143.516 215.141 171.737 222.585C189.936 227.384 202.607 247.216 203.378 265.294C203.467 272.78 202.257 280.12 198.55 288.675C190.427 307.422 177.924 315.999 158.5 322.34C141.979 327.733 114 321.971 114 321.971C143.5 332.47 203.5 337.97 254 303.973Z",
  fill: "url(#paint12_radial_1367:2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M282.672 176.134C315.628 179.492 325.5 202.982 325.5 202.982C324.795 207.916 323.136 213.468 321 217.98L282.672 176.134Z",
  fill: "url(#paint13_radial_1367:2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M254 303.973C270.511 235.778 236.734 216.16 225.061 211.525C237.5 211.525 255.5 215.223 269.5 235.5C259.903 190.038 213.239 171.188 171.737 184.5C145.237 193 96 225.225 85.5 227.363C75 229.5 70 227.5 66.5 226.5C70 229.5 85 237.136 91 238.5C118.114 244.662 143.516 215.141 171.737 222.585C189.936 227.384 202.607 247.216 203.378 265.294C203.467 272.78 202.257 280.12 198.55 288.675C190.427 307.422 177.924 315.999 158.5 322.34C141.979 327.733 114 321.971 114 321.971C143.5 332.47 203.5 337.97 254 303.973Z",
  fill: "url(#paint14_radial_1367:2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M282.672 176.134C315.628 179.492 325.5 202.982 325.5 202.982C324.795 207.916 323.136 213.468 321 217.98L282.672 176.134Z",
  fill: "url(#paint15_radial_1367:2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M180.5 328.898C160 334 64.4999 321.954 69.4999 299.5C92.9999 311 118.161 318.351 150 315C179.069 311.94 203.248 296.017 202.878 264.908C202.425 254.288 198.755 244.723 191.802 236.612C217 263.5 212 313 180.5 328.898Z",
  fill: "url(#paint16_linear_1367:2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M180.5 328.898C160 334 64.4999 321.954 69.4999 299.5C92.9999 311 118.161 318.351 150 315C179.069 311.94 203.248 296.017 202.878 264.908C202.425 254.288 198.755 244.723 191.802 236.612C217 263.5 212 313 180.5 328.898Z",
  fill: "url(#paint17_radial_1367:2)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.99,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M147.5 138.5C147.5 138.5 138.339 140.256 135 144.5C135 144.5 131.147 150.322 125.5 156.5C115.444 161.878 109.5 163.5 109.5 163.5C109.5 163.5 110 147.775 112.5 145.5C117.5 142 134 138.5 147.5 138.5Z",
  fill: "url(#paint18_linear_1367:2)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.99,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M145.5 139.5C145.5 139.5 137.001 142.452 134 146C134 146 131 152 129.5 154.5C125.35 158.937 110 163.5 110 163.5C110 163.5 111 153 113.5 147.5C115.039 144.115 126 141.5 145.5 139.5Z",
  fill: "#7333D8"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M379 227.8L408.9 206.8C422.9 226 439.1 235.6 457.5 235.6C466.3 235.6 473.2 233.7 478.2 229.9C483.2 225.9 485.7 220.5 485.7 213.7C485.7 208.1 484 203.8 480.6 200.8C477.2 197.6 470.5 193.7 460.5 189.1L439.2 179.5C407.2 165.3 391.2 146.3 391.2 122.5C391.2 105.7 397.4 92.2 409.8 82C422.2 71.6 437.9 66.4 456.9 66.4C471.7 66.4 484.7 69.8 495.9 76.6C507.1 83.2 515.9 92.3 522.3 103.9L494.7 125.2C484.5 110 471.9 102.4 456.9 102.4C449.7 102.4 443.8 104.1 439.2 107.5C434.6 110.9 432.3 115.6 432.3 121.6C432.3 126.6 433.9 130.7 437.1 133.9C440.5 136.9 446.6 140.4 455.4 144.4L477.9 154.3C494.9 161.9 507.3 170.2 515.1 179.2C522.9 188 526.8 199 526.8 212.2C526.8 230 520.3 244.4 507.3 255.4C494.3 266.2 477.7 271.6 457.5 271.6C440.9 271.6 425.9 267.7 412.5 259.9C399.3 252.1 386.8 241.4 379 227.8Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M671.878 138.4C685.678 153 692.578 171.4 692.578 193.6C692.578 215.8 685.678 234.4 671.878 249.4C658.278 264.2 641.178 271.6 620.578 271.6C601.978 271.6 587.178 265.6 576.178 253.6V322H535.678V119.5H572.878V138.1C583.078 123.5 598.978 116.2 620.578 116.2C641.178 116.2 658.278 123.6 671.878 138.4ZM651.478 193.9C651.478 181.7 647.878 171.8 640.678 164.2C633.478 156.6 624.278 152.8 613.078 152.8C602.278 152.8 593.278 156.4 586.078 163.6C579.078 170.8 575.578 180.8 575.578 193.6C575.578 206.4 579.078 216.5 586.078 223.9C593.278 231.1 602.278 234.7 613.078 234.7C624.078 234.7 633.178 230.9 640.378 223.3C647.778 215.7 651.478 205.9 651.478 193.9Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M846.85 207.4H742.75C745.15 216.8 749.95 224.1 757.15 229.3C764.55 234.3 773.65 236.8 784.45 236.8C799.05 236.8 812.85 231.8 825.85 221.8L842.65 249.4C824.85 264.2 805.05 271.6 783.25 271.6C760.45 272 741.05 264.6 725.05 249.4C709.25 234 701.55 215.5 701.95 193.9C701.55 172.5 709.05 154.1 724.45 138.7C739.85 123.3 758.25 115.8 779.65 116.2C800.05 116.2 816.75 122.8 829.75 136C842.95 149.2 849.55 165.6 849.55 185.2C849.55 192.4 848.65 199.8 846.85 207.4ZM742.75 178.9H810.25C810.05 169.9 806.85 162.7 800.65 157.3C794.65 151.7 787.15 148.9 778.15 148.9C769.55 148.9 762.05 151.6 755.65 157C749.25 162.4 744.95 169.7 742.75 178.9Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M855.751 193.6C855.751 172 863.451 153.7 878.851 138.7C894.251 123.7 913.051 116.2 935.251 116.2C964.451 116.2 985.951 128.4 999.751 152.8L971.551 174.7C961.551 160.3 949.651 153.1 935.851 153.1C924.451 153.1 915.051 157 907.651 164.8C900.451 172.4 896.851 182 896.851 193.6C896.851 205.4 900.451 215.2 907.651 223C915.051 230.6 924.451 234.4 935.851 234.4C949.651 234.4 961.551 227.3 971.551 213.1L999.751 234.7C993.151 246.3 984.251 255.4 973.051 262C962.051 268.4 949.451 271.6 935.251 271.6C913.451 272 894.651 264.5 878.851 249.1C863.051 233.5 855.351 215 855.751 193.6Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M1104.08 234.1V268C1094.5 268 1095.5 268 1086.5 268C1067.5 268 1055.48 266.9 1045.08 257.5C1034.88 248.1 1029.78 234.2 1029.78 215.8V153.7H1006.38V119.5H1029.78V82H1070.28V119.5H1104.28V153.7H1070.28V212.2C1070.28 220.6 1072.38 226.6 1076.58 230.2C1080.78 233.8 1091.24 234.1 1104.08 234.1Z",
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M1208.5 119.5L1192.68 155.7C1180.3 155.7 1172.95 157.5 1165 165C1158 171.6 1155.98 181.3 1155.98 193.9V268H1115.48V119.5H1152.68V141.2C1162.5 119.5 1184.5 119.5 1208.5 119.5Z",
  fill: "black"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M1313.16 119.5H1350.36V268H1312.56V250.6C1301.76 264.6 1286.06 271.6 1265.46 271.6C1244.66 271.6 1227.46 264.3 1213.86 249.7C1200.26 234.9 1193.46 216.3 1193.46 193.9C1193.46 171.5 1200.26 153 1213.86 138.4C1227.46 123.6 1244.66 116.2 1265.46 116.2C1286.46 116.2 1302.36 123.5 1313.16 138.1V119.5ZM1299.66 223.9C1306.86 216.7 1310.46 206.7 1310.46 193.9C1310.46 181.1 1306.86 171.1 1299.66 163.9C1292.46 156.5 1283.56 152.8 1272.96 152.8C1261.96 152.8 1252.76 156.7 1245.36 164.5C1238.16 172.1 1234.56 181.9 1234.56 193.9C1234.56 205.9 1238.16 215.7 1245.36 223.3C1252.76 230.9 1261.96 234.7 1272.96 234.7C1283.76 234.7 1292.66 231.1 1299.66 223.9Z",
  fill: "black"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M1363.53 268V43H1404.03V268H1363.53Z",
  fill: "black"
});

var _ref12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f_1367:2",
  x: 104,
  y: 19,
  width: 118,
  height: 13,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "effect1_foregroundBlur_1367:2"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f_1367:2",
  x: 179,
  y: 46.6272,
  width: 78.5283,
  height: 8.35242,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "effect1_foregroundBlur_1367:2"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_f_1367:2",
  x: 236,
  y: 80,
  width: 67.5283,
  height: 6.97961,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "effect1_foregroundBlur_1367:2"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_f_1367:2",
  x: 78,
  y: 50,
  width: 71,
  height: 8,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "effect1_foregroundBlur_1367:2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1367:2",
  x1: 249,
  y1: 23,
  x2: 89,
  y2: 311,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A359EC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5117CA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_1367:2",
  x1: 217,
  y1: 147,
  x2: 271.5,
  y2: 308,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F2F0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6E3FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_1367:2",
  x1: 191.646,
  y1: 97.8742,
  x2: 268.993,
  y2: 178.491,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B5ABEC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E2DCFF"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial_1367:2",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(256 123) rotate(99.4623) scale(21.2897 59.6873)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AA6EDA",
  stopOpacity: 0.76
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E2DCFF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_1367:2",
  x1: 137.5,
  y1: 50,
  x2: 130.5,
  y2: 90,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B3A8EC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F1EFFF"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint5_radial_1367:2",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(136.5 56) rotate(138.24) scale(18.7683 50.1658)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8F5BD1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F1EFFF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_1367:2",
  x1: 149.5,
  y1: 196,
  x2: 233.991,
  y2: 295.508,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.552083,
  stopColor: "#D3CCF6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E7E4FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_1367:2",
  x1: 149.5,
  y1: 196,
  x2: 233.991,
  y2: 295.508,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.552083,
  stopColor: "#D3CCF6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E7E4FD"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint8_radial_1367:2",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(247 183.5) rotate(112.62) scale(97.5 418.141)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0833333,
  stopColor: "#BCA6EA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint9_radial_1367:2",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(247 183.5) rotate(112.62) scale(97.5 418.141)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0833333,
  stopColor: "#BCA6EA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint10_radial_1367:2",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(298 179) rotate(120.53) scale(22.6385 63.3348)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B7A0E7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ECE9FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint11_radial_1367:2",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(298 179) rotate(120.53) scale(22.6385 63.3348)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B7A0E7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ECE9FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint12_radial_1367:2",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(145.5 164) rotate(42.337) scale(121.754 126.752)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0833333,
  stopColor: "#825AC5",
  stopOpacity: 0.71
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint13_radial_1367:2",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(145.5 164) rotate(42.337) scale(121.754 126.752)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0833333,
  stopColor: "#825AC5",
  stopOpacity: 0.71
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint14_radial_1367:2",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(51.5 242.5) rotate(1.42764) scale(160.55 167.14)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0833333,
  stopColor: "#825AC5",
  stopOpacity: 0.71
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint15_radial_1367:2",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(51.5 242.5) rotate(1.42764) scale(160.55 167.14)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0833333,
  stopColor: "#825AC5",
  stopOpacity: 0.71
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear_1367:2",
  x1: 198.5,
  y1: 276.5,
  x2: 191.496,
  y2: 319.999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D9D3F8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E8E4FE"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint17_radial_1367:2",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(130 256) rotate(84.7582) scale(54.7289 336.192)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5A2DDB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EEEBFF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear_1367:2",
  x1: 116,
  y1: 145.987,
  x2: 151,
  y2: 147.487,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B7ADEA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F4FF"
})));

var SvgSpectralFullLogo = function SvgSpectralFullLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1405,
    height: 330,
    viewBox: "0 0 1405 330",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1367:2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 330,
    height: 330
  }, _ref2), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpectralFullLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spectral-full-logo.158d9126.svg";
export { ForwardRef as ReactComponent };